import getColor from "@insite/mobius/utilities/getColor";
import { blogCardStyles as styles } from "@solveindustrial/Components/BlogCard";
import { customLinkCallToActionStyles } from "@solveindustrial/Utilities/styleguide/link";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        border: 1px solid ${getColor(colorStrings.commonGlobalGray03)};
        border-radius: 4px;
        overflow: hidden;
        height: 100%;
        width: 100%;
    `,
};

styles.textWrapper = {
    ...styles.textWrapper,
    css: css`
        padding: 24px;
        display: flex;
        flex-direction: column;
        height: 100%;

        ${mediaQueriesBP.maxMD} {
            padding: 16px;
        }
    `,
};

styles.title = {
    ...styles.title,
    css: css`
        margin-bottom: 8px;
        * {
            font-size: 18px;

            ${mediaQueriesBP.maxMD} {
                font-size: 16px;
            }
        }
    `,
};

styles.readMore = {
    ...styles.readMore,
    css: css`
        ${styles.readMore?.css}
        ${customLinkCallToActionStyles}

        margin-top: auto;

        span {
            &:first-child {
                display: none;
            }
        }
    `,
};

styles.summary = {
    ...styles.summary,
    css: css`
        ${styles.summary?.css}
        max-height: 120px;
        margin-bottom: 8px;
    `,
};
